import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileSlide = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_4491_6107",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#232930"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_4491_6107)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.25 21C4.63125 21 4.10156 20.7797 3.66094 20.3391C3.22031 19.8984 3 19.3688 3 18.75V5.25C3 4.63125 3.22031 4.10156 3.66094 3.66094C4.10156 3.22031 4.63125 3 5.25 3H18.75C19.3688 3 19.8984 3.22031 20.3391 3.66094C20.7797 4.10156 21 4.63125 21 5.25V18.75C21 19.3688 20.7797 19.8984 20.3391 20.3391C19.8984 20.7797 19.3688 21 18.75 21H5.25ZM18.75 9.75V5.25H10.875V8.625C10.875 8.94375 10.9828 9.21094 11.1984 9.42656C11.4141 9.64219 11.6813 9.75 12 9.75H18.75Z",
			fill: "#232930"
		})
	})]
});
export default SvgFileSlide;
